var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMastercardLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 36,
    viewBox: "0 0 57 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_865_731)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.6213 4.12534L20.4579 4.12534V31.3599H35.6213V4.12534Z",
    fill: "#FF5F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4223 17.7408C21.4223 12.2179 24.0121 7.29634 28.0413 4.12595C25.0952 1.8071 21.3742 0.421555 17.3307 0.421555C7.76092 0.421555 0.00115967 8.17674 0.00115967 17.7408C0.00115967 27.3049 7.76092 35.0601 17.3307 35.0601C21.3742 35.0601 25.0904 33.6746 28.0413 31.3557C24.0121 28.1853 21.4223 23.2638 21.4223 17.7408Z",
    fill: "#EB001B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0811 17.7406C56.0811 27.3047 48.3214 35.0599 38.7516 35.0599C34.7081 35.0599 30.9919 33.6743 28.041 31.3555C32.0702 28.1851 34.66 23.2635 34.66 17.7406C34.66 12.2177 32.0702 7.29613 28.041 4.12574C30.9871 1.80688 34.7081 0.421341 38.7516 0.421341C48.3214 0.421341 56.0811 8.17653 56.0811 17.7406Z",
    fill: "#F79E1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.426 28.4721V27.9144H54.6521V27.799H54.0796V27.9144H54.3057V28.4721H54.4308H54.426ZM55.5372 28.4721V27.799H55.364L55.162 28.2606L54.9599 27.799H54.7868V28.4721H54.9118V27.9673L55.0995 28.4048H55.2293L55.417 27.9673V28.4769H55.542L55.5372 28.4721Z",
    fill: "#F79E1B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_865_731"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 57,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercardLogo);
export default __webpack_public_path__ + "static/media/mastercard-logo.715141f08a15f72fd7823f1565699f37.svg";
export { ForwardRef as ReactComponent };